import Dashboard from './dashboard';
import ArticleStockRoutes from './article_stock';
import DemandeTransfertRoutes from './demande-transfert';
import TransfertRoutes from './transfert';
import PosteChargeRoutes from './poste-charge';
import ChecklistRoutes from './checklist';
import NomenclatureRoutes from './nomenclature';
import OfRoutes from './of';
import SuiviOFRoutes from './suivi-of';

export default [
  ...Dashboard,
  ...ArticleStockRoutes,
  ...DemandeTransfertRoutes,
  ...TransfertRoutes,
  ...PosteChargeRoutes,
  ...ChecklistRoutes,
  ...NomenclatureRoutes,
  ...OfRoutes,
  ...SuiviOFRoutes,
];
